import React from "react"
import Settings from "../../../../utils/CarrotConfig"
import L10n from "lib/carrot-l10n"
import { NavItemWithIcon } from "./NavItem"
import { MaybeLink } from "../../atoms/links/MaybeLink"
import { Spacer } from "../../atoms/Atoms"
import { BodySmall } from "../../atoms/Bodies"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const NavLinkWithIcon = ({ children, onClick, to = "#", enabled = true, ...props }) => {
  const className = `
    flex flex-row no-underline dib animate-all pointer dim pl2 black-80
    ${enabled ? "" : "o-60"}`

  return (
    <MaybeLink className={className} to={to} onClick={onClick} enabled={enabled} {...props}>
      <div>
        <Spacer width={0.5} />
        <BodySmall color="black-80" display="di" weight="normal">
          {children}
        </BodySmall>
      </div>
    </MaybeLink>
  )
}

const SupportCenterNav = () => {
  const supportCenterUrl = Settings.ZENDESK_GUIDE

  async function goToSupportCenter() {
    window.open(supportCenterUrl, "_blank")
  }

  return (
    <div>
      <NavLinkWithIcon onClick={goToSupportCenter}>
        <NavItemWithIcon
          icon="icn-lifebuoy"
          id="nav-support-center-link"
          link={supportCenterUrl}
          text={l`Support Center`}
        />
      </NavLinkWithIcon>
    </div>
  )
}

export { SupportCenterNav }
